import { Card, CardMedia, CardContent, Typography, CardActions, Button, Switch, Box, CardHeader, IconButton, Menu, MenuItem, Paper, Stack, useMediaQuery, useTheme } from '@mui/material';
import { Add, MoreVert } from '@mui/icons-material';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import Banner from './Banner';

const Sale = ({ data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const fecha = parseISO(data?.created_at);
  const zonaHoraria = 'America/Buenos_Aires';
  const fechaEnZonaHoraria = utcToZonedTime(fecha, zonaHoraria);
  const fechaFormateada = format(fechaEnZonaHoraria, "PPPP", { timeZone: zonaHoraria, locale: es });
  return (
    <Box display='flex' sx={{ padding: 0 }} justifyContent='center'>
      <Card sx={{ width: isMobile ? '90%' : '50%', marginY: 3, marginX: 0, paddingX: 0 }} elevation={4}>
        <CardHeader
          title={data?.article?.name}
          subheader={fechaFormateada}
        // action={
        //   <MenuCustom
        //     Child={() => <MoreVert />}
        //     options={[{ name: 'Vender', id: 'sale' }, { name: 'Agregar stock', id: 'addstock' }]}
        //     optionsSelected={(idoption) => optionSelected(idoption, article)}
        //   />
        // }
        />
        {/* <CardMedia
          sx={{ height: 200, objectFit: 'contain' }}
          component='div'
        > */}
        {/* <Banner images={article.images} /> */}
        {/* </CardMedia> */}
        <CardContent>
          {/* <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
            <Box display='flex' >
              <Banner images={data?.article?.images} height={100} />
              <Box>
                <Box display='flex'>
                  <Typography variant="body2" color="text.secondary">
                    {'Precio de lista'}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div">
                    {data.prices.list_price}
                  </Typography>
                </Box>
                <Box display='flex'>
                  <Typography variant="body2" color="text.secondary">
                    {'Precio de venta'}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div">
                    {data.prices.sale_price}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box display='flex'>
                  <Typography variant="body2" color="text.secondary">
                    {'Precio vendido'}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div">
                    {data.prices_sold.sale_price}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {'Cantidad vendida'}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div">
                    {data.prices_sold.sale_price}
                  </Typography>
                </Box>
                <Box display='flex'>
                  <Typography variant="body2" color="text.secondary">
                    {'Descuento'}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div">
                    {data.prices.discount.porcentage}%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box display='flex' flexDirection='column' alignItems='flex-end'>
              <Typography variant="body2" color="text.secondary">
                ${'article.prices?.list_price'}
              </Typography>
              <Typography variant="h6" color="text.secondary">
                <span>${'article.prices?.sale_price'}</span>
              </Typography>
            </Box>
          </Box> */}
          <Stack direction="Column" spacing={2} display='flex' gap={1}>
            <Box display='flex' sx={{ width: '100%', height: 180 }} gap={1}>
              <Paper variant='elevation' elevation={5} sx={{ width: '100%', height: 180 }}>
                <Banner images={data?.article?.images} height={120} />
                <Typography variant="body2" color="text.secondary">
                  {data.article.description}
                </Typography>
              </Paper>
              <Paper variant='elevation' elevation={5} sx={{ width: '100%', height: 180 }}>
                <Box display='flex' flexDirection='column' justifyContent='space-between' height='100%' marginBottom={4} marginX={2}>
                  <Box>
                    <Typography variant="h6" gutterBottom color="text.secondary" alignContent='space-between'>
                      Venta
                    </Typography>
                    <Box display='flex' flexDirection='column'>
                      <Box display='flex' flexDirection='row' justifyContent='space-between'>
                        <Typography variant="body2" color="text.secondary" alignContent='space-between'>
                          SKU:
                        </Typography>
                        <Typography variant="body2" color="text.secondary" alignContent='space-between'><span>{data.sku}</span></Typography>
                      </Box>
                      <Box display='flex' flexDirection='row' justifyContent='space-between'>
                        <Typography variant="body2" color="text.secondary">
                          Cantidad:
                        </Typography>
                        <Typography variant="body2" color="text.secondary" alignContent='space-between'><span>{data.quantity_sold}</span></Typography>
                      </Box>
                      <Box display='flex' flexDirection='row' justifyContent='space-between'>
                        <Typography variant="body2" color="text.secondary">
                          $ Unid:
                        </Typography>
                        <Typography variant="body2" color="text.secondary" alignContent='space-between'><span>$ {data.prices_sold.sale_price}</span></Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                    <Typography variant="body2" color="text.secondary">
                      $ total:
                    </Typography>
                    <Typography variant="h6" color="darkgrey" alignContent='space-between'><span>$ {data.prices_sold.sale_price * data.quantity_sold}</span></Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
            {/* <Box display='flex' sx={{ width: '100%', height: 180 }} gap={1}>
              <Paper variant='elevation' elevation={5} sx={{ width: '100%', height: 180 }} />
              <Paper variant='elevation' elevation={5} sx={{ width: '100%', height: 180 }} />
            </Box> */}
          </Stack>
        </CardContent>
        <CardActions>
          <Box display='flex' flexDirection='row' sx={{ width: '100%' }} justifyContent='flex-end' flexWrap='wrap'>
            <Typography gutterBottom variant="h6" component="div" paddingX={2}>
              Disponibles: 
            </Typography>
            <Typography variant="h6" color="CaptionText" alignContent='space-between'> <span>{ data.current_stock}</span></Typography>
          </Box>
        </CardActions>
      </Card>
    </Box>
  )
}

export default Sale;